import { ReactComponent as ErrorSVG } from "./svg/icon_Error.svg";

export const IconError = () => {
  return (
    <span>
      <ErrorSVG />
    </span>
  );
};
